<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	import { calibrate_cover } from '../../../../helpers/requests/calibrate_cover';
	//Design system componets
	import { Alert, Button, Text } from '@Shelly/shelly-design-system';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device;

	let local_ip = get_local_ip(device.id);
	let loading = false;

	const startCalibration = async () => {
		loading = true;
		await calibrate_cover(
			{ [real_id(device.id)]: readDeviceStatus(device.id) },
			device,
			local_ip,
		).then(() => (loading = false));
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: startCalibration,
				loading,
				disabled: loading,
				label: $format('button_start_calibration'),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Text styleType="body-small" class="mb-s">
	{$format('calib_description', {
		default: 'Calibration allows your cover to have position control.',
	})}
</Text>
<Alert
	type="info"
	isHeadingBold
	heading={$format('label_info')}
	message={$format('calib_warn_description', {
		default: 'Please make sure that there are no obstacles in the way during the calibration.',
	})}
/>
{#if !$showNewLayout}
	<Button class="mt-s" {loading} size="m" width="full" on:click={startCalibration}>
		{$format('button_start_calibration')}
	</Button>
{/if}
